import React, { useEffect, useContext } from 'react';
import SharedReportHeader from '@nile/reports/src/modules/reports/components/subpages/SharedReportHeader';
import { ExportContext } from '@nile/components';
import { RETAINER_REPORT } from '@nile/reports/src/modules/home/constants';
import { SharedRetainerReportSheet } from '@nile/reports/src/modules/RetinerReport/components/pages/RetainerReportSheet';
import { Modal } from './styles';
import SharedReportGrid from '../SharedReportGrid';

const SharedReportSheet = (props) => {
  const { data, isExport } = props;
  const exportContext = useContext(ExportContext);

  useEffect(() => {
    if (isExport) {
      exportContext.setIsRendered(true);
    }
  }, [data]);

  return (
    <Modal className="fx">
      <div className="FormContainer Modal-Wrap">
        {!isExport && <SharedReportHeader data={data} />}
        <div className="fx reportSection">
          {data?.reportName === 'Retainer Report' ? (
            <SharedRetainerReportSheet data={data} />
          ) : (
            <SharedReportGrid
              layout={data?.layout?.layout || []}
              isExport={isExport}
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default SharedReportSheet;
